<template>
  <v-container fluid>
    <div>
      <div class="text-h4 mb-5 mt-5">
        Saldos de bolsas
        <v-chip
          v-if="asientosSeleccionados.length > 0"
          class="ma-2"
          color="primary"
          close
          outlined
          @click:close="setAsientosSeleccionados([])"
        >
          {{ asientosSeleccionados.length }} seleccionados
        </v-chip>
        <v-chip
          v-if="cantidadSeleccionadosNoVisibles > 0"
          class="ma-2"
          color="on secondary"
          close
          outlined
          @click:close="eliminarSeleccionadosNoVisibles()"
        >
          {{ cantidadSeleccionadosNoVisibles }} seleccionados no visibles
        </v-chip>
      </div>
    </div>
    <v-card :loading="loading">
      <v-app-bar flat dense color="rgba(0, 0, 0, 0)">
        <v-spacer></v-spacer>
        <v-speed-dial
          v-model="fabDots"
          direction="left"
          transition="slide-x-reverse-transition"
          ><template v-slot:activator>
            <v-btn icon v-model="fabDots">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                dark
                small
                color="green lighten-1"
                @click="
                  $store.dispatch('imprimirListado', {
                    type: 'excel',
                    fechaRegistro: fechaAsiento,
                    asientos: asientosSeleccionados,
                  })
                "
              >
                <v-badge
                  :content="asientosSeleccionados.length"
                  :value="asientosSeleccionados.length"
                  color="red"
                >
                  <v-icon>mdi-microsoft-excel</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span> Exportar los saldos selccionados a Excel</span>
          </v-tooltip>
        </v-speed-dial>
      </v-app-bar>
      <v-card-title style="padding-top: 0px; padding-bottom: 0px">
        <v-row>
          <v-col cols="12" sm="3">
            <date-picker
              v-bind:date="fechaAsiento"
              v-bind:title="fechaAsientoTitulo"
              v-bind:conIcono="false"
              v-bind:clearable="false"
              @actualizarFecha="reloadAsientosAlCambiarFecha"
            ></date-picker>
          </v-col>
          <!-- <v-dialog
          ref="dialogFechaAsiento"
          v-model="modalFechaAsiento"
          :return-value.sync="fechaAsiento"
          persistent
          width="290"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="fechaAsientoFormateada"
              label="Fecha asiento"
              v-bind="attrs"
              v-on="on"
              @blur="fechaAsiento = parseDate(fechaAsientoFormateada)"
              readonly
              single-line
              hide-details
            ></v-text-field>
          </template>
          <v-date-picker v-model="fechaAsiento" scrollable :first-day-of-week="1">
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="modalFechaAsiento = false"
              >Cancelar</v-btn
            >
            <v-btn text color="primary" @click="reloadAsientosAlCambiarFecha()"
              >Aceptar</v-btn
            >
          </v-date-picker>
        </v-dialog> -->
          <v-spacer></v-spacer>
          <v-col cols="12" sm="3">
            <v-select
              v-model="contratoFiltro"
              label="Contrato"
              :items="contratos"
              :loading="loadingContratos"
              item-text="contrato"
              item-value="id"
              return-object
              hide-details
              class="mb-5 mx-auto"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="3">
            <v-spacer></v-spacer>
            <v-text-field
              v-model="buscarAsientos"
              append-icon="mdi-account-search-outline"
              label="Buscar"
              single-line
              hide-details
              class="mb-5 mx-auto"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="asientos"
        :search="buscarAsientos"
        class="elevation-1"
        multi-sort
        show-select
        v-model="asientosSeleccionados"
        @current-items="getVisible"
        :item-class="noSelected"
        sort-desc
        sort-by="fechaApertura"
      >
        <template v-slot:item.fechaApertura="{ item }">
          <span>{{ formatDate(item.fechaApertura) }}</span>
        </template>

        <!-- :items-per-page="-1" -->
        <!-- <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
            style="border: 2px solid #000; justify-content: center"
          />
        </template> -->
      </v-data-table>
    </v-card>
    <v-dialog v-model="confirmarAnulacion" persistent width="500">
      <v-card>
        <v-card-title class="headline">¡Atención!</v-card-title>
        <v-card-text
          ><div>Se anularán los asientos seleccionados.</div>
          <!-- <div class="text-h6 primary--text">{{ fechaAsientoFormateada }}</div> -->
          <div>¿Estás seguro?</div></v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="anularAsientosCancel()">Cancelar</v-btn>
          <!-- <v-btn color="error" text @click="anularAsientos()">Continuar</v-btn> -->
          <v-btn color="error" text @click="anularAsientosSeleccionados()"
            >Continuar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-speed-dial
      v-model="fab"
      fixed
      direction="top"
      transition="slide-y-reverse-transition"
      style="bottom: 37px; right: 30px"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="teal lighten-1" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            fab
            dark
            small
            color="green"
            @click="crearAsientos()"
            @keydown.ctrl="ctrlPulsado = true"
          >
            <v-icon>mdi-file-document-outline</v-icon>
          </v-btn>
        </template>
        <span
          >Crea asientos de cierre en la fecha indicada para los contratos
          seleccionados.</span
        >
      </v-tooltip>

      <!-- OPCION 1 : CANCELAR ASIENTOS DE UNA FECHA -->
      <!-- <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            fab
            dark
            small
            color="red"
            @click="anularAsientosConfirm()"
            @keydown.ctrl="ctrlPulsado = true"
          >
            <v-icon>mdi-file-cancel-outline</v-icon>
          </v-btn>
        </template>
        <span>Anula un asiento según la fecha indicada.</span>
      </v-tooltip> -->

      <!-- OPCION 2 : CANCELAR ASIENTOS A PARTIR DE UNA SELECCION CLIENTE-CONTRATO -->
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            fab
            dark
            small
            color="red"
            @click="anularAsientosConfirm()"
            @keydown.ctrl="ctrlPulsado = true"
          >
            <v-icon>mdi-file-cancel-outline</v-icon>
          </v-btn>
        </template>
        <span>Anula los asientos seleccionados.</span>
      </v-tooltip>
    </v-speed-dial>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import formatearFecha from "../../mixins/formatearFecha";

import Datepicker from "../../components/utils/Datepicker";
import { required } from "vuelidate/lib/validators";
import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

export default {
  name: "Asientos",
  mixins: [formatearFecha],
  components: {
    "date-picker": Datepicker,
  },
  data: () => ({
    fabDots: false,
    buscarAsientos: "",
    fechaAsiento: "",
    fechaAsientoTitulo: "Fecha Asiento",
    fechaAsientoFormateada: "",
    fab: false,
    modalFechaAsiento: false,
    loading: false,
    loadingContratos: false,
    contratoFiltro: {
      id: 99,
      contrato: "Todos",
    },
    confirmarAnulacion: false,
  }),
  methods: {
    ...mapActions([
      "setAsientosSeleccionados",
      "setAsientosVisibles",
      "eliminarSeleccionadosNoVisibles",
      "setLoading",
      "setSnackbar",
    ]),

    loadAsientos() {
      this.asientosSeleccionados = [];
      this.loading = true;
      this.$store
        .dispatch("getAsientos", this.fechaAsiento)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.setSnackbar({
            tipo: "error",
            mensaje: "No se han podido recuperar los asientos.",
          });
          this.loading = false;
          this.loadingContratos = false;
        });
    },
    loadData() {
      this.loadingContratos = true;
      this.initFecha();
      this.loadAsientos();
      this.$store
        .dispatch("getContratos")
        .then(() => {
          this.loadingContratos = false;
        })
        .catch(() =>
          this.setSnackbar({
            tipo: "error",
            mensaje: "No se han podido recuperar los contratos.",
          })
        );
    },
    crearAsientos() {
      this.loading = true;
      console.log(this.asientosSeleccionados);
      if (this.asientosSeleccionados.length) {
        axios
          .post("api/asientos", {
            asientos: this.asientosSeleccionados,
            fechaRegistro: this.fechaAsiento,
          })
          .then((res) => {
            console.log(res);
            this.loading = false;
            this.loadAsientos();

            this.setSnackbar({
              tipo: "success",
              mensaje: "Asientos guardados correctamente.",
            });
          })
          .catch((error) => {
            console.log(error);
            this.loading = false;
            this.setSnackbar({
              tipo: "error",
              mensaje: "No se han podido generar los asientos",
            });
          });
      } else this.mostrarErrorSinAsientosSeleccionados();
    },
    anularAsientosConfirm() {
      this.confirmarAnulacion = true;
    },
    anularAsientosCancel() {
      this.confirmarAnulacion = false;
    },
    anularAsientosSeleccionados() {
      if (this.asientosSeleccionados.length) {
        console.log(this.asientosSeleccionados);
        axios
          .post("api/asientos/anular", {
            asientos: this.asientosSeleccionados,
          })
          .then((res) => {
            this.loadAsientos();
            this.setSnackbar({
              tipo: "success",
              mensaje: `Asientos anulados correctamente.`,
            });
          })
          .catch((err) => {
            console.log(err);
            this.setSnackbar({
              tipo: "error",
              mensaje: `Se ha producido un error al anular los asientos seleccionados.`,
            });
          });
        this.confirmarAnulacion = false;
      } else this.mostrarErrorSinAsientosSeleccionados();
    },
    mostrarErrorSinAsientosSeleccionados() {
      this.setSnackbar({
        tipo: "error",
        mensaje: "Se debe seleccionar por lo menos un registro para procesar.",
      });
    },
    getVisible(e) {
      this.asientosVisibles = e;
    },
    initFecha() {
      this.fechaAsiento = new Date(new Date().getFullYear() - 1, 12, 1);
      this.fechaAsiento = this.fechaAsiento.toISOString().substr(0, 10);
      this.fechaAsientoFormateada = this.formatDate(this.fechaAsiento);
    },
    noSelected(asiento) {
      if (!this.asientosSeleccionados.includes(asiento)) {
        return "disabledRow";
      }

      return "";
    },
    reloadAsientosAlCambiarFecha(val) {
      this.fechaAsiento = val;
      this.loadAsientos();
    },
  },
  computed: {
    ...mapGetters({
      asientos: "asientos",
      contratos: "contratos",
      seleccionados: "asientosSeleccionados",
      visibles: "asientosVisibles",
      cantidadSeleccionadosNoVisibles: "cantidadSeleccionadosNoVisibles",
    }),
    asientosSeleccionados: {
      get() {
        return this.seleccionados;
      },
      set(newAsientosSeleccionados) {
        return this.setAsientosSeleccionados(newAsientosSeleccionados);
      },
    },
    asientosVisibles: {
      get() {
        return this.visibles;
      },
      set(newAsientosVisibles) {
        return this.setAsientosVisibles(newAsientosVisibles);
      },
    },

    headers() {
      return [
        {
          text: "Cliente",
          filterable: true,
          sortable: true,
          value: "cliente",
        },
        {
          text: "Tipo contrato",
          filterable: true,
          sortable: true,
          value: "tipoContrato",
          filter: (value) => {
            if (!this.contratoFiltro || this.contratoFiltro.id == 99)
              return true;
            return value == this.contratoFiltro.contrato;
          },
        },
        {
          text: "Fecha último asiento apertura",
          filterable: true,
          sortable: true,
          value: "fechaApertura",
        },
        {
          text: "Horas acumuladas",
          filterable: true,
          sortable: true,
          value: "horas",
        },
      ];
    },
  },
  created() {
    this.loadData();
  },

  watch: {
    fechaAsiento() {
      this.fechaAsientoFormateada = this.formatDate(this.fechaAsiento);
    },
  },
};
</script>

<style>
</style>

